import { FlexBox, FlexBoxProps } from '@ardoq/layout';
import styled from 'styled-components';
import { FormSize } from '../../types';
import { FORM_FOOTER_SELECTOR } from '../FormFooter/FormFooter';
import { s16 } from '@ardoq/design-tokens';
import { BUTTON_SELECTOR } from '@ardoq/button';

type StyledFormWrapperProps = {
  $formSize: FormSize;
};

const StyledFormWrapper = styled(FlexBox)<StyledFormWrapperProps>`
  width: ${({ $formSize }) => $formSize};

  ${FORM_FOOTER_SELECTOR} {
    margin-top: ${s16};
  }

  & > ${BUTTON_SELECTOR} {
    align-self: start;
  }
`;

export const FORM_WRAPPER_SELECTOR = StyledFormWrapper.toString();

type FormWrapperProps = Pick<
  FlexBoxProps,
  | 'gap'
  | 'padding'
  | 'paddingLeft'
  | 'paddingRight'
  | 'backgroundColor'
  | 'className'
  | 'style'
  | 'children'
> & {
  formSize?: FormSize;
};

export const FormWrapper = ({
  formSize = FormSize.DEFAULT,
  gap = 'medium',
  ...rest
}: FormWrapperProps) => (
  <StyledFormWrapper
    flexDirection="column"
    $formSize={formSize}
    gap={gap}
    {...rest}
  />
);
